var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonitoring01 = function SvgMonitoring01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "monitoring-01_svg2__a",
    x1: 2.01,
    x2: 176.01,
    y1: 167.76,
    y2: 12.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#monitoring-01_svg2__a",
    id: "monitoring-01_svg2__b",
    x1: -3.92,
    x2: 170.08,
    y1: 161.11,
    y2: 6.11
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#monitoring-01_svg2__a",
    id: "monitoring-01_svg2__c",
    x1: 16.03,
    x2: 190.03,
    y1: 183.51,
    y2: 28.51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#monitoring-01_svg2__a",
    id: "monitoring-01_svg2__d",
    x1: 10.41,
    x2: 184.41,
    y1: 177.2,
    y2: 22.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#monitoring-01_svg2__a",
    id: "monitoring-01_svg2__e",
    x1: -2.12,
    x2: 171.88,
    y1: 163.13,
    y2: 8.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#monitoring-01_svg2__a",
    id: "monitoring-01_svg2__f",
    x1: 34.04,
    x2: 208.04,
    y1: 203.72,
    y2: 48.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#monitoring-01_svg2__a",
    id: "monitoring-01_svg2__g",
    x1: 25.34,
    x2: 199.34,
    y1: 193.96,
    y2: 38.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#monitoring-01_svg2__a",
    id: "monitoring-01_svg2__h",
    x1: 16.65,
    x2: 190.65,
    y1: 184.2,
    y2: 29.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#monitoring-01_svg2__a",
    id: "monitoring-01_svg2__i",
    x1: 28.74,
    x2: 202.74,
    y1: 197.77,
    y2: 42.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#monitoring-01_svg2__a",
    id: "monitoring-01_svg2__j",
    x1: 41.96,
    x2: 215.96,
    y1: 212.62,
    y2: 57.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#monitoring-01_svg2__a",
    id: "monitoring-01_svg2__k",
    x1: -32.14,
    x2: 141.86,
    y1: 129.43,
    y2: -25.57
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M180.47 8.22h-62.89c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5h62.89c6.69 0 12.12 5.44 12.12 12.12v89.95h-77.84c6.85-8.13 10.99-18.62 10.99-30.05 0-25.77-20.96-46.73-46.73-46.73S32.28 61.47 32.28 87.24c0 7.8 1.93 15.14 5.32 21.61l-8.74 8.74H7.41V27.34c0-6.69 5.44-12.12 12.12-12.12h62.89c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5H19.53C8.99 8.22.41 16.8.41 27.34v106.25c0 3.49.99 6.93 2.78 9.9-4.08 5.48-3.65 13.28 1.32 18.25 2.73 2.73 6.31 4.09 9.9 4.09s7.17-1.36 9.9-4.09l9.02-9.02H71.8l-3.85 14.88h-4.66c-6.67 0-12.09 5.42-12.09 12.09s5.43 12.09 12.09 12.09h73.44c6.67 0 12.09-5.42 12.09-12.09s-5.42-12.09-12.09-12.09h-4.66l-3.85-14.88h52.27c10.55 0 19.12-8.58 19.12-19.12V27.34c0-10.55-8.58-19.12-19.12-19.12ZM79 47.51c21.91 0 39.73 17.82 39.73 39.73S100.91 126.97 79 126.97s-39.73-17.82-39.73-39.73S57.09 47.51 79 47.51m-57.15 77.08L8.29 138.15c-.58-1.43-.89-2.96-.89-4.56v-9zm-2.5 32.2a7.007 7.007 0 0 1-9.9 0 7.007 7.007 0 0 1 0-9.9l23.32-23.32 8.62-8.63c2.79 3.77 6.13 7.11 9.9 9.9l-21.9 21.9zm122.46 22.9c0 2.81-2.29 5.09-5.09 5.09H63.28c-2.81 0-5.09-2.29-5.09-5.09s2.29-5.09 5.09-5.09h73.44c2.81 0 5.09 2.29 5.09 5.09m-16.99-12.1H75.17l3.85-14.88h41.95zm55.65-21.87H40.32l17.07-17.07A46.4 46.4 0 0 0 79 133.97c10.69 0 20.54-3.61 28.42-9.67h85.17v9.3c0 6.69-5.44 12.12-12.12 12.12",
    style: {
      fill: "url(#monitoring-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 107.28c12.8 0 24.43-7.06 30.36-18.42a3.5 3.5 0 0 0 0-3.24C103.43 74.26 91.8 67.2 79 67.2s-24.43 7.06-30.36 18.42a3.5 3.5 0 0 0 0 3.24c5.93 11.36 17.56 18.42 30.36 18.42m0-26.83c3.74 0 6.79 3.04 6.79 6.79A6.79 6.79 0 1 1 79 80.45m23.24 6.79a27.15 27.15 0 0 1-17.1 12.33c4.53-2.26 7.65-6.93 7.65-12.33s-3.12-10.06-7.65-12.33a27.18 27.18 0 0 1 17.1 12.33M72.87 74.91c-4.53 2.26-7.65 6.93-7.65 12.33s3.12 10.06 7.65 12.33a27.18 27.18 0 0 1-17.1-12.33 27.15 27.15 0 0 1 17.1-12.33",
    style: {
      fill: "url(#monitoring-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.11 55.92c0 1.93 1.57 3.5 3.5 3.5h39.3c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5h-39.3c-1.93 0-3.5 1.57-3.5 3.5",
    style: {
      fill: "url(#monitoring-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.91 40.67c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5H156.3c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5z",
    style: {
      fill: "url(#monitoring-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.51 35.83c-.09-.21-.2-.41-.32-.6-.13-.19-.28-.37-.44-.53-.16-.17-.34-.31-.53-.44s-.39-.23-.6-.32-.43-.16-.66-.2c-.45-.09-.91-.09-1.36 0-.23.04-.45.11-.66.2s-.41.19-.6.32-.37.27-.53.44a3.46 3.46 0 0 0-.96 3.16c.04.22.11.44.2.65.08.21.19.41.32.6.13.2.27.37.44.54.16.16.34.3.53.43s.39.24.6.32c.21.09.43.16.66.2.22.05.45.07.68.07s.46-.02.68-.07c.23-.04.45-.11.66-.2.21-.08.41-.19.6-.32s.37-.27.53-.43c.65-.66 1.03-1.56 1.03-2.48 0-.23-.02-.46-.07-.68-.04-.23-.11-.45-.2-.66",
    style: {
      fill: "url(#monitoring-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.14 73.33c-.09-.21-.2-.41-.32-.6-.13-.19-.28-.37-.44-.54a3.53 3.53 0 0 0-3.16-.95c-.22.04-.44.11-.65.2s-.42.19-.61.32-.37.27-.53.43c-.16.17-.31.35-.43.54q-.195.285-.33.6c-.08.21-.15.43-.19.66-.05.22-.07.45-.07.68 0 .92.37 1.82 1.02 2.48.16.16.34.3.53.43s.4.24.61.32c.21.09.43.16.65.2.23.05.46.07.68.07.23 0 .46-.02.69-.07.22-.04.44-.11.65-.2.22-.08.42-.19.61-.32s.37-.27.53-.43c.65-.66 1.03-1.56 1.03-2.48a3.604 3.604 0 0 0-.27-1.34",
    style: {
      fill: "url(#monitoring-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.17 72.73c-.13-.19-.28-.37-.44-.53-.16-.17-.34-.31-.53-.44s-.39-.23-.6-.32a3.51 3.51 0 0 0-3.82.76c-.65.65-1.02 1.55-1.02 2.47 0 .23.02.46.07.68.04.23.11.45.19.66q.135.315.33.6c.12.2.27.37.43.54a3.52 3.52 0 0 0 2.48 1.02c.22 0 .45-.02.68-.07.22-.04.44-.11.66-.2.21-.08.41-.19.6-.32s.37-.27.53-.43c.16-.17.31-.34.44-.54.12-.19.23-.39.32-.6a3.6 3.6 0 0 0 .27-1.34 3.604 3.604 0 0 0-.27-1.34c-.09-.21-.2-.41-.32-.6",
    style: {
      fill: "url(#monitoring-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7 76.61c.12.2.27.37.43.54a3.514 3.514 0 0 0 4.95 0c.65-.66 1.03-1.56 1.03-2.48a3.604 3.604 0 0 0-.27-1.34c-.09-.21-.2-.41-.32-.6-.13-.19-.28-.37-.44-.53-1.3-1.31-3.65-1.31-4.95 0a3.496 3.496 0 0 0-.43 4.41",
    style: {
      fill: "url(#monitoring-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.61 96.92h12.54c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5h-12.54c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5",
    style: {
      fill: "url(#monitoring-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.84 93.42c0 1.93 1.57 3.5 3.5 3.5h12.87c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5h-12.87c-1.93 0-3.5 1.57-3.5 3.5",
    style: {
      fill: "url(#monitoring-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 15.22c.92 0 1.82-.37 2.47-1.03.17-.16.31-.34.44-.53s.23-.39.32-.6.16-.43.2-.66c.05-.22.07-.45.07-.68s-.02-.46-.07-.69c-.04-.22-.11-.44-.2-.65s-.19-.41-.32-.6c-.13-.2-.27-.37-.44-.54-.16-.16-.34-.3-.53-.43a3 3 0 0 0-.6-.32c-.21-.09-.43-.16-.66-.2-.45-.09-.91-.09-1.36 0-.23.04-.45.11-.66.2-.21.08-.41.19-.6.32s-.37.27-.53.43c-.17.17-.31.34-.44.54-.13.19-.23.39-.32.6s-.16.43-.2.65a3.482 3.482 0 0 0 .96 3.16c.65.66 1.55 1.03 2.47 1.03",
    style: {
      fill: "url(#monitoring-01_svg2__k)"
    }
  }));
};
export default SvgMonitoring01;